import React, { useState, useEffect, useContext, useRef } from 'react';
import { MasonryPhotoAlbum } from 'react-photo-album';
import "react-photo-album/masonry.css";
import { AuthContext } from "../AuthContext"; // update path if needed
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import Download from 'yet-another-react-lightbox/plugins/download';

export default function Galerie() {
  const [photos, setPhotos] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentImage, setCurrentImage] = useState(-1);
  const { getToken } = useContext(AuthContext);
  // Ref to remember scroll position before opening lightbox
  const scrollPosition = useRef(0);

  useEffect(() => {
    const loadGallery = async () => {
      setLoading(true);
      setError(null);
      try {
        // Retrieve auth token
        const token = await getToken();
        // Fetch gallery with Authorization header
        const res = await fetch('/api/galerie', {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json'
          }
        });
        if (!res.ok) {
          if (res.status === 401) {
            throw new Error('Unauthorized access. Please log in.');
          }
          throw new Error(`Error fetching gallery: ${res.status} ${res.statusText}`);
        }
        const data = await res.json();
        setPhotos(
          data.map((pic) => ({
            src: pic.url,
            width: pic.width ?? 4,
            height: pic.height ?? 3,
            alt: pic.filename,
          }))
        );
      } catch (err) {
        console.error('Gallery error:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    loadGallery();
  }, [getToken]);

  // Restore scroll position when lightbox closes
  useEffect(() => {
    if (currentImage < 0) {
      window.scrollTo(0, scrollPosition.current);
    }
  }, [currentImage]);

  return (
    <>
      <style>{`
        /* Remove borders and shadows from gallery images */
        .react-photo-album--photo {
          border: none !important;
          box-shadow: none !important;
          outline: none !important;
        }
        .yarl__button {
          border: none !important;
          box-shadow: none !important;
          outline: none !important;
        }
        .yarl__button.yarl__download {
          /* Position at top-right, matching other controls */
          position: absolute;
          top: 16px;
          right: 16px;
        }
      `}</style>
      <div className="header-custom"></div>
      {loading ? (
        <div>Loading gallery...</div>
      ) : error ? (
        <div className="error">{error}</div>
      ) : (
        <>
          <MasonryPhotoAlbum
            photos={photos}
            onClick={({ index }) => {
              scrollPosition.current = window.scrollY;
              setCurrentImage(index);
            }}
          />
          <Lightbox
            open={currentImage >= 0}
            close={() => setCurrentImage(-1)}
            slides={photos.map(photo => ({ src: photo.src }))}
            index={currentImage}
            plugins={[Download]}
          />
        </>
      )}
    </>
  );
}